import type { ManagerAuthorization } from '@common/enums';
import type { AccountRequestAuthorizationType } from '@frontend/utils/hasAuthorization';
import { AuthorizationErrorCode } from '@common/enums';
import { hasAccountRequestAuthorization, hasOneAuthorization } from '@frontend/utils/hasAuthorization';

export function assertHasAuthorization(authorizations: ManagerAuthorization | ManagerAuthorization[]): void {
    if (!hasOneAuthorization(Array.isArray(authorizations) ? authorizations : [authorizations])) {
        throw new Error(AuthorizationErrorCode.MISSING_MANAGER_ROLE_AUTHORIZATION);
    }
}

export function assertHasAccountRequestAuthorization(type: 'create' | 'read', isOnlyForKsyos?: boolean): void;
export function assertHasAccountRequestAuthorization(
    type: 'review',
    isOnlyForKsyos: boolean,
    accountRequestApproverId?: string
): void;
export function assertHasAccountRequestAuthorization(
    type: Exclude<AccountRequestAuthorizationType, 'create' | 'read' | 'review'>
): void;
export function assertHasAccountRequestAuthorization(
    type: AccountRequestAuthorizationType,
    isOnlyForKsyos?: boolean | string,
    accountRequestApproverId?: string
): void {
    // @ts-expect-error - TS doesn't know that the function is being called with the correct arguments
    const accountRequestAuthorization = hasAccountRequestAuthorization(type, isOnlyForKsyos, accountRequestApproverId);

    if (type === 'review' && !isOnlyForKsyos) {
        if (!accountRequestApproverId) {
            throw new Error(AuthorizationErrorCode.MISSING_ACCOUNT_REQUEST_APPROVER_ID);
        }
    }

    if (!accountRequestAuthorization) {
        throw new Error(AuthorizationErrorCode.MISSING_ACCOUNT_REQUEST_AUTHORIZATION);
    }
}
